module.exports = __webpack_public_path__ + "static/media/galerija_2019 (10).ad285d6b.jpg";